import { useCallback } from 'react';
import { isUndefined } from 'lodash';

import { useSearchQuery, useSearchSelector } from '../../store';

export const useSearchResults = (size: number) => {
    const { query } = useSearchSelector();
    const { data, isFetching, isError, refetch } = useSearchQuery({ query, size }, { skip: !query.trim() });

    const hasMore = !isError && (isUndefined(data) || Boolean(data?.length));

    const loadMore = useCallback(() => {
        if (hasMore && !isFetching) {
            refetch();
        }
    }, [hasMore, isFetching, refetch]);

    return { data: data ?? [], isLoading: isFetching, loadMore, hasMore };
};
